import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Helpers } from 'src/app/helpers/helpers';
import { AnswerSchema, CustomTest, QuestionSchema } from 'src/app/models/custom_test_model';
import { CustomTestService } from 'src/app/services/custom-test.service';
import { TestService } from 'src/app/services/test.service';
import Swal from 'sweetalert2';
declare var Quill: any;

@Component({
  selector: 'app-custom-form',
  templateUrl: './custom-form.component.html',
  styleUrls: ['./custom-form.component.css']
})
export class CustomFormComponent implements OnInit {

  public test?: CustomTest;
  public welcome = true;
  public formEnded = false;
  public countdown = 10800;
  public timer: any;
  public formStarted = false;
  public formModel = [];
  public answers = [];
  public selectedQuestion?: QuestionSchema;
  public selectedQuestionIndex = 0;
  public canGoBack = false;
  public testTimer: any;
  public testTimerQty = 0;
  public instructionTimer: any;
  public instructionTimerQty = 0;
  public showInstructions = true;
  public isTimedQuestion = false;
  public trigger = false;
  
  public questionTimer: any;
  public questionTimerQty = 0;
  public showQuestion = true;

  public descriptionEditor: any;
  public questionEditor: any;
  public instructionsEditor: any;
  public fieldValue: any;
  public conditionalField = '';
  public questionSelected = false;
  public testData: any;

  constructor(
    private customTestService: CustomTestService,
    private route: ActivatedRoute,
    private testService: TestService,
    private router: Router
  ) { }

  ngOnInit(): void {
    if (!this.testService.selectedTestData){
      this.router.navigate(['/dashboard/requestedTests']);
      return
    }
    this.testData = this.testService.selectedTestData;

    let id = this.route.snapshot.paramMap.get('formId');
    this.customTestService.getCustomTests({_id: id}).subscribe(
      resp => {
        this.test = resp[0];
        if (this.test.random){
          this.test.questions = this.setRandomQuestions(this.test.randomQty, this.test.questions);
        }
        // console.log(this.test)

        setTimeout(() => {
          this.updateEditor('.description-editor', this.test.description)

        }, 300)
        this.test.questions.forEach((question, index) => {
          // this.formModel[index] = [];
          this.answers[index] = [];
        })
        this.selectedQuestion = this.test.questions[this.selectedQuestionIndex];
        if (this.test.canGoBack){
          this.canGoBack = true;
        }
        // console.log(this.selectedQuestion)

      }
    )
  }

  setRandomQuestions(quantity: number, dataSet: QuestionSchema[]){
    if (quantity > dataSet.length){
      quantity = dataSet.length;
    }
    let questions = [];
    let usedIndexes = [];
    for (let i = 0; i < quantity; i++){
      let randomIndex = Helpers.getRandomInt(0, dataSet.length - 1);
      while (usedIndexes.includes(randomIndex)){
        randomIndex = Helpers.getRandomInt(0, dataSet.length - 1);
      }
      usedIndexes.push(randomIndex);
      this.formModel.push(randomIndex);
      questions.push(dataSet[randomIndex]);
    }
    return questions;
  }

  startForm(){
    if (this.test.secureTest){
      document.addEventListener("visibilitychange", () => {
        if (document.visibilityState === 'visible') {
          
        } else {
  
          Swal.fire({
            icon: 'warning',
            text: 'La prueba ha sido bloqueada por cambiar de pestaña o minimizar la ventana',
            confirmButtonText: 'Aceptar'
          }).then(() => {
            this.router.navigateByUrl('dashboard/requestedTests').then(() => {
              location.reload()
            });
          })
        }
      });
    }
    let testData = this.testService.selectedTestData;
    if (testData.camera){
      setTimeout(() => {
        this.trigger = !this.trigger;
      }, Math.floor(Math.random() * 60000 + 240000));
    }
    testData.isStarted = true;
    testData.startDate = Date.now();
    // this.testService.updateTest(testData).subscribe();
    this.timer = setInterval(() => {
      this.countdown--;
      if (this.countdown <= 0){
        clearInterval(this.timer);
        location.reload()
      }
      if (this.countdown == 120){
        Swal.fire({
          position: 'top-end',
          icon: 'warning',
          text: 'Quedan 2 minutos para que el formulario se cierre automáticamente',
          showConfirmButton: false,
          timer: 3000
        })
      }
    }, 1000)

    if (this.test.timer && this.test.timerQty > 0){
      this.testTimerQty = this.test.timerQty * 60;
      this.testTimer = setInterval(() => {
        this.testTimerQty--;
        if (this.testTimerQty <= 0){
          clearInterval(this.testTimer);
          this.formEnded = true;
          this.sendForm();
        }
      }, 1000)
    }

    if (this.selectedQuestion.instructionsTimer > 0){
      this.isTimedQuestion = true;
      this.instructionTimerQty = this.selectedQuestion.instructionsTimer;
      this.instructionTimer = setInterval(() => {
        this.instructionTimerQty--;
        if (this.instructionTimerQty <= 0){
          clearInterval(this.instructionTimer);
          this.showInstructions = false;
        }
      }, 1000)
    }

    if (this.selectedQuestion.questionTimer > 0){
      this.questionTimerQty = this.selectedQuestion.questionTimer;
      this.questionTimer = setInterval(() => {
        this.questionTimerQty--;
        if (this.questionTimerQty <= 0){
          clearInterval(this.questionTimer);
          this.showQuestion = false;
        }
      }, 1000)
    }



    setTimeout(() => {
      this.updateEditor('.question-editor', this.selectedQuestion.question);
      this.updateEditor('.instructions-editor', this.selectedQuestion.instructions);
    }, 300)
  }

  async sendForm(){
    // console.log(this.formModel)
    this.formStarted = false;
    let points = this.calculateFormPoints();
    let obj = {
      _id:this.testService.selectedTestData._id,
      formData:this.formModel,
      isCompleted:true,
      completeDate:Date.now(),
      formScore:points,
      evaluatedName: this.testService.selectedTestData.evaluatedName,
      client: this.testService.selectedTestData.client,
      type: this.testService.selectedTestData.type,
      isCustomBrand: this.testService.selectedTestData.isCustomBrand,
      answers: this.answers
    }
    this.testService.updateTest(obj, false).subscribe(
      async resp=>{
        Swal.fire({
          text: 'Prueba finalizada',
          icon: 'success',
          timer: 2000
        }).then(()=>{
          this.router.navigate(['/dashboard/requestedTests']);
        })
      },
      err=>console.log(err)
    );
  }


  toggleSelectedOption(question: number, option: string, multi: boolean, id: string){
    if (!this.selectedQuestion.canChangeAnswer && this.questionSelected){
      return Swal.fire({
        icon: 'warning',
        text: 'Usted debe responder de una forma u otra la opción seleccionada, no es posible cambiarla.',
        confirmButtonText: 'Aceptar'
      })
    }

    this.questionSelected = true;
    if (multi){

      if (this.answers[question]){
        if (this.answers[question].find((item) => item.answer == option)){
          this.answers[question] = this.answers[question].filter(item => item.answer !== option);
        }else{
          this.answers[question].push({id: id, answer: option});
        }
      }else{
        this.answers[question] = [{
          id: id,
          answer: option
        }];
      }
    }else{
      this.answers[question] = [{
        id: id,
        answer: option
      }];
      
    }

  }

  scrollTop(){
    window.scrollTo(0, 100);
  }
  
  
  next(){
    // console.log(this.formModel)
    // console.log(this.selectedQuestion)
    this.scrollTop();
    if (this.answers[this.selectedQuestionIndex].length == 0 && this.selectedQuestion.type != 'text'){
      return Swal.fire({
        icon: 'warning',
        text: 'Por favor seleccione una opción',
        confirmButtonText: 'Aceptar'
      })
    }

    if (this.selectedQuestion.type == 'text' && (!this.fieldValue || this.fieldValue.length == 0)){
      return Swal.fire({
        icon: 'warning',
        text: 'Por favor ingrese una respuesta',
        confirmButtonText: 'Aceptar'
      })
    }

    this.questionSelected = false;
    if (this.selectedQuestion.type == 'text' || this.selectedQuestion.type == 'number'){
      let obj = {
        id: '',
        answer: this.fieldValue
      }
      this.answers[this.selectedQuestionIndex] = [obj];
      this.fieldValue = '';
    }

    if (this.selectedQuestion.type == 'conditional'){
      let isCorrect = false;
      try {
        this.selectedQuestion.answers.forEach((answer) => {
          if ((answer.title == this.answers[this.selectedQuestionIndex][0].answer) && answer.requestInput){
            isCorrect = true;
          }
        })
        
      } catch (error) {
        return Swal.fire({
          icon: 'warning',
          text: 'Por favor seleccione una opción',
          confirmButtonText: 'Aceptar'
        })
      }
      if (isCorrect && !this.conditionalField){
        return Swal.fire({
          icon: 'warning',
          text: 'Si seleccionó una opción que requiere mas información por favor respóndala',
          confirmButtonText: 'Aceptar'

        })  
      }
      let obj = {
        id: this.answers[this.selectedQuestionIndex].length > 0 ? this.answers[this.selectedQuestionIndex][0].id : '',
        answer: this.answers[this.selectedQuestionIndex].length > 0 ? this.answers[this.selectedQuestionIndex][0].answer + ' - ' + this.conditionalField : ''
      }

      this.answers[this.selectedQuestionIndex] = [obj];
      this.conditionalField = '';
    }

    this.isTimedQuestion = false;
    if (this.instructionTimer){
      clearInterval(this.instructionTimer);
    }
    this.showInstructions = true;
    this.showQuestion = true;
    this.selectedQuestionIndex++;
    this.selectedQuestion = this.test.questions[this.selectedQuestionIndex];
    if (!this.selectedQuestion){
      this.trigger = !this.trigger;
      return this.sendForm();
    }
    setTimeout(() => {
      this.updateEditor('.question-editor', this.selectedQuestion.question);
      this.updateEditor('.instructions-editor', this.selectedQuestion.instructions);
    }, 300)
    if (this.selectedQuestion.instructionsTimer > 0){
      this.isTimedQuestion = true;
      this.instructionTimerQty = this.selectedQuestion.instructionsTimer;
      this.instructionTimer = setInterval(() => {
        this.instructionTimerQty--;
        if (this.instructionTimerQty <= 0){
          clearInterval(this.instructionTimer);
          this.showInstructions = false;
        }
      }, 1000)
    }else{
      this.instructionTimer = null;
    }

    if (this.selectedQuestion.questionTimer > 0){
      this.isTimedQuestion = true;
      this.questionTimerQty = this.selectedQuestion.questionTimer;
      this.questionTimer = setInterval(() => {
        this.questionTimerQty--;
        if (this.questionTimerQty <= 0){
          clearInterval(this.questionTimer);
          this.showQuestion = false;
        }
      }, 1000)
    }else{
      this.questionTimer = null;
    }
  }

  back(){
    if (this.selectedQuestionIndex == 0){
      return
    }
    if (this.test.questions[this.selectedQuestionIndex - 1].instructionsTimer > 0 || this.test.questions[this.selectedQuestionIndex - 1].questionTimer > 0){
      return Swal.fire({
        icon: 'warning',
        text: 'En las preguntas con temporizador de visualización no es posible retroceder',
      })
    }
    this.selectedQuestionIndex--;
    this.selectedQuestion = this.test.questions[this.selectedQuestionIndex];
    this.fieldValue = this.answers[this.selectedQuestionIndex].length > 0 ? this.answers[this.selectedQuestionIndex][0].answer : '';
    setTimeout(() => {
      this.updateEditor('.question-editor', this.selectedQuestion.question);
      this.updateEditor('.instructions-editor', this.selectedQuestion.instructions);
    }, 300)
  }

  isSelected(question: number, option: string){
    if (this.answers[question]){
      return this.answers[question].some( a => a.answer == option )
    }
    return false;
  }

  calculateFormPoints(){
    let points = 0;
    this.test.questions.forEach((question, index) => {
      let allCorrects = true;
      if (this.answers[index].length == 0){
        allCorrects = false;
      }
      this.answers[index].forEach((answer) => {

        let answ: AnswerSchema = question.answers.find((ans) => ans._id == answer.id);
        if (!answ || !answ.correct){
          allCorrects = false;
        }
      })
      if (allCorrects){
        points ++;
      }
    })
    return points;

  }

  secondsToStringTime(seconds: number){
    let minutes = Math.floor(seconds / 60);
    let sec = seconds % 60;
    let secondsString = sec < 10 ? `0${sec}` : `${sec}`;
    return `${minutes}:${secondsString}`
  }


  reload(){
    location.reload()
  }


  updateEditor(element: string, data){

    var options = {
      modules: {
        toolbar: null
      },
      placeholder: '',
      theme: 'snow',
      readOnly: true,
      border: false
    };
    let editor = new Quill(element, options)
    editor.setContents(data);

  }

  
}


